import React, { lazy } from 'react';

// --------- LAZY COMPONENTS
const LazyCourseOverView = lazy(() => import('./components/course-overview'));
const LazyFeaturedCourse = lazy(() =>
  import('./components/course-overview/components/featured-courses')
);
const LazyRelatedCourse = lazy(() =>
  import('./components/course-overview/components/related-courses')
);
const LazyPopularCourse = lazy(() =>
  import('./components/course-overview/components/popular-courses')
);
const LazyAllCourse = lazy(() =>
  import('./components/course-overview/components/all-courses')
);
const LazyCourseDetails = lazy(() =>
  import('./components/course-overview/components/course-details')
);
const LazyMyCourses = lazy(() => import('./components/mycourses/components'));
const LazyMyCourseDetails = lazy(() =>
  import('./components/mycourses/components/mycoursedetails')
);
const LazyLiveClasses = lazy(() => import('./components/livesessions'));
const LazyLiveClasseDetails = lazy(() =>
  import('./components/livesessions/components/session-details')
);
const LazyMySessions = lazy(() => import('./components/mysessions/components'));
const LazyEventOverView = lazy(() => import('./components/event-overview'));
const LazySessions = lazy(() => import('./components/sessions/components'));
const LazyMyTickets = lazy(() => import('./components/mytickets'));
const LazyGallery = lazy(() => import('./components/gallery'));
const LazySurvey = lazy(() => import('./components/survey'));
const LazyAgenda = lazy(() => import('./components/agenda'));
const LazyAutoLogin = lazy(() => import('./components/autologin'));
const LazyMyProfile = lazy(() => import('./components/myprofile'));
const LazyNews = lazy(() => import('./components/news/components'));
const LazyNewsDetails = lazy(() =>
  import('./components/news/components/newsdetails')
);
const LazyUsersChat = lazy(() => import('./components/userschat/components'));
const LazyAttendee = lazy(() => import('./components/attendee/components'));
const LazyExhibitors = lazy(() => import('./components/exhibitors'));
const LazySponsors = lazy(() => import('./components/sponsors'));
const LazySpeakers = lazy(() => import('./components/speakers/components'));
const LazyBookmarks = lazy(() => import('./components/bookmarks/components'));
const LazyCommonDetails = lazy(() =>
  import('./components/Common/common-details')
);
const LazyPolls = lazy(() => import('./components/polls'));
const LazyFourZeroFour = lazy(() => import('./components/Common/pagenotfound'));
const LazyCommunityForum = lazy(() =>
  import('./components/community-forum/components')
);
const LazySocial = lazy(() => import('./components/social/components'));
const LazyGamification = lazy(() =>
  import('./components/gamification/components')
);
const LazyMaps = lazy(() => import('./components/maps'));
const LazyNotes = lazy(() => import('./components/notes/components'));
const LazyEventWebview = lazy(() => import('./components/event-webview'));
const LazyMapDetails = lazy(() =>
  import('./components/maps/components/mapdetails')
);
const LazyEventGuide = lazy(() => import('./components/event-guide'));
const LazyNotifications = lazy(() =>
  import('./components/notifications/components')
);
const LazyGlobalSearch = lazy(() =>
  import('./components/global-search/components')
);
const LazyMyScans = lazy(() => import('./components/myscans/components'));

// Languages
import LocalStrings from './languages';
import { DEVELOPMENT_TYPE } from './components/Common/constant';
import appIcons from './components/Common/appIcons';

var routes =
  DEVELOPMENT_TYPE === 'koachify'
    ? [
        {
          path: '/overview',
          name: LocalStrings.kOverviewText,
          languageKey: 'kOverviewText',
          icon: appIcons.koachifyexploreIcon,
          // component: CourseOverView,
          component: LazyCourseOverView,
          display: true,
          position: 'leftside',
          key: 'overview'
        },
        {
          path: '/featured-courses',
          name: '',
          languageKey: '',
          icon: '',
          // component: FeaturedCourse,
          component: LazyFeaturedCourse,
          display: false,
          position: ''
        },
        {
          path: '/related-courses',
          name: '',
          languageKey: '',
          icon: '',
          // component: RelatedCourse,
          component: LazyRelatedCourse,
          display: false,
          position: ''
        },
        {
          path: '/popular-courses',
          name: '',
          languageKey: '',
          icon: '',
          // component: PopularCourse,
          component: LazyPopularCourse,
          display: false,
          position: ''
        },
        {
          path: '/all-courses',
          name: '',
          languageKey: '',
          icon: '',
          // component: AllCourse,
          component: LazyAllCourse,
          display: false,
          position: ''
        },
        {
          path: '/mycourses',
          name: LocalStrings.mycourses,
          languageKey: 'mycourses',
          icon: appIcons.mycoursesIcon,
          // component: MyCourses,
          component: LazyMyCourses,
          display: true,
          position: 'leftside',
          key: 'mycourses'
        },
        {
          path: '/liveclasses',
          name: LocalStrings.kSessionsText,
          languageKey: 'kSessionsText',
          icon: appIcons.liveclassesIcon,
          // component: LiveClasses,
          component: LazyLiveClasses,
          display: true,
          position: 'leftside',
          key: 'schedule'
        },
        {
          path: '/liveclass-details',
          name: '',
          languageKey: '',
          icon: '',
          // component: LiveClasseDetails,
          component: LazyLiveClasseDetails,
          display: false,
          position: ''
        },
        {
          path: '/mysessions',
          name: LocalStrings.mysessions,
          languageKey: 'mysessions',
          icon: appIcons.mysessionsIcon,
          // component: MySessions,
          component: LazyMySessions,
          display: true,
          position: 'leftside',
          key: 'mysessions'
        },
        {
          path: '/course-details',
          name: '',
          languageKey: '',
          icon: '',
          // component: CourseDetails,
          component: LazyCourseDetails,
          display: false,
          position: ''
        },
        // {
        //   path: '/polls',
        //   name: LocalStrings.kPollsText,
        // languageKey: 'kPollsText',
        //   icon: appIcons.pollsIcon,
        //   // component: LazyPolls,
        //   display: true,
        //   position: 'leftside',
        // key: 'polls'
        // },
        {
          path: '/mycoursedetails',
          name: '',
          languageKey: '',
          icon: '',
          // component: MyCourseDetails,
          component: LazyMyCourseDetails,
          display: false,
          position: ''
        },
        {
          path: '/myprofile',
          name: LocalStrings.kProfileText,
          languageKey: 'kProfileText',
          icon: appIcons.profileIcon,
          // component: MyProfile,
          component: LazyMyProfile,
          display: true,
          position: 'top',
          key: 'myprofile'
        },
        // {
        //   path: '/news',
        //   name: LocalStrings.kNewsText,
        // languageKey: 'kNewsText',
        //   icon: appIcons.mycoursesIcon,
        //   // component: LazyNews,
        //   display: true,
        // position: 'leftside',
        // key: 'news'
        // },
        // {
        //   path: '/newsdetails',
        //   name: '', languageKey: '',
        //   icon: '',
        //   // component: LazyNewsDetails,
        //   display: false,
        // position: ''
        // },
        {
          path: '/chat',
          name: LocalStrings.kChat,
          languageKey: 'kChat',
          icon: appIcons.chatIcon,
          // component: UsersChat,
          component: LazyUsersChat,
          display: true,
          position: 'leftside',
          key: 'message'
        },
        {
          path: '/attendee',
          name: LocalStrings.kAttendeeText,
          languageKey: 'kAttendeeText',
          icon: appIcons.attendeesIcon,
          // component: Attendee,
          component: LazyAttendee,
          display: true,
          position: 'leftside',
          key: 'attendee'
        },
        {
          path: '/fourzerofour',
          name: '',
          languageKey: '',
          icon: '',
          // component: FourZeroFour,
          component: LazyFourZeroFour,
          display: false,
          position: ''
        }
      ]
    : [
        {
          path: '/overview',
          name: LocalStrings.kOverviewText,
          languageKey: 'kOverviewText',
          icon: appIcons.homeIcon,
          // component: EventOverView,
          component: LazyEventOverView,
          display: true,
          position: 'leftside',
          section: '',
          key: 'overview'
        },
        {
          path: '/sessions',
          name: LocalStrings.kSessionsText,
          languageKey: 'kSessionsText',
          icon: appIcons.sessionsIcon,
          // component: Sessions,
          component: LazySessions,
          display: true,
          position: 'leftside',
          section: '',
          key: 'schedule'
        },
        {
          path: '/exhibitors',
          name: LocalStrings.kExhibitorsTxt,
          languageKey: 'kExhibitorsTxt',
          icon: appIcons.exhibitorsIcon,
          // component: Exhibitors,
          component: LazyExhibitors,
          display: true,
          position: 'leftside',
          section: '',
          key: 'exhibitor'
        },
        {
          path: '/exhibitor-details/:exhibitorid',
          name: '',
          languageKey: '',
          icon: '',
          // component: CommonDetails,
          component: LazyCommonDetails,
          display: false,
          position: '',
          section: ''
        },
        {
          path: '/sponsors',
          name: LocalStrings.kSponsorsTxt,
          languageKey: 'kSponsorsTxt',
          icon: appIcons.sponsorsIcon,
          // component: Sponsors,
          component: LazySponsors,
          display: true,
          position: 'leftside',
          section: '',
          key: 'sponsor'
        },
        {
          path: '/sponsor-details/:sponsorid',
          name: '',
          languageKey: '',
          icon: '',
          // component: CommonDetails,
          component: LazyCommonDetails,
          display: false,
          position: '',
          section: ''
        },
        {
          path: '/speakers',
          name: LocalStrings.kSpeakersTxt,
          languageKey: 'kSpeakersTxt',
          icon: appIcons.speakersIcon,
          // component: Speakers,
          component: LazySpeakers,
          display: true,
          position: 'leftside',
          section: '',
          key: 'speaker'
        },
        {
          path: '/myprofile',
          name: LocalStrings.kEditProfile,
          languageKey: 'kEditProfile',
          icon: appIcons.profileIcon,
          // component: MyProfile,
          component: LazyMyProfile,
          display: true,
          position: 'top',
          // section: 'side',
          section: '',
          key: 'profile'
        },
        {
          path: '/bookmarks',
          name: LocalStrings.kBookmarksText,
          languageKey: 'kBookmarksText',
          icon: appIcons.bookmarksIcon,
          // component: Bookmarks,
          component: LazyBookmarks,
          display: true,
          position: 'top',
          key: 'bookmark',
          section: 'menu'
        },
        {
          path: '/bookmarked-newsdetails',
          name: '',
          languageKey: '',
          icon: '',
          // component: NewsDetails,
          component: LazyNewsDetails,
          display: false,
          position: '',
          section: ''
        },
        // {
        //   path: '/polls',
        //   name: LocalStrings.kPollsText,
        // languageKey: 'kPollsText',
        //   icon: appIcons.pollsIcon,
        //   // component: LazyPolls,
        //   display: true,
        //   position: 'leftside'
        // key:'polls'
        // },
        {
          path: '/news',
          name: LocalStrings.kNewsText,
          languageKey: 'kNewsText',
          icon: appIcons.newsIcon,
          // component: News,
          component: LazyNews,
          display: true,
          position: 'leftside',
          section: '',
          key: 'news'
        },
        {
          path: '/newsdetails',
          name: '',
          languageKey: '',
          icon: '',
          // component: NewsDetails,
          component: LazyNewsDetails,
          display: false,
          section: '',
          position: ''
        },
        {
          path: '/chat',
          name: LocalStrings.kChat,
          languageKey: 'kChat',
          icon: appIcons.chatIcon,
          // component: UsersChat,
          component: LazyUsersChat,
          display: true,
          position: 'leftside',
          section: '',
          key: 'message'
        },
        {
          path: '/attendee',
          name: LocalStrings.kAttendeeText,
          languageKey: 'kAttendeeText',
          icon: appIcons.attendeesIcon,
          // component: Attendee,
          component: LazyAttendee,
          display: true,
          position: 'leftside',
          section: '',
          key: 'attendee'
        },
        {
          path: '/fourzerofour',
          name: '',
          languageKey: '',
          icon: '',
          // component: FourZeroFour,
          component: LazyFourZeroFour,
          display: false,
          section: '',
          position: ''
        },
        {
          path: '/autologin',
          name: '',
          languageKey: '',
          icon: '',
          // component: AutoLogin,
          component: LazyAutoLogin,
          display: false,
          section: '',
          position: ''
        },
        {
          path: '/community-forum',
          name: LocalStrings.kCommunityText,
          languageKey: 'kCommunityText',
          icon: appIcons.communityIcon,
          // component: CommunityForum,
          component: LazyCommunityForum,
          display: true,
          position: 'leftside',
          section: '',
          key: 'community'
        },
        {
          path: '/social',
          name: LocalStrings.social_menu_text,
          languageKey: 'social_menu_text',
          icon: appIcons.socialIcon,
          // component: Social,
          component: LazySocial,
          display: true,
          position: 'leftside',
          section: '',
          key: 'social'
        },
        {
          path: '/gamification',
          name: LocalStrings.kGamificationsText,
          languageKey: 'kGamificationsText',
          icon: appIcons.gamificationIcon,
          // component: Gamification,
          component: LazyGamification,
          display: true,
          position: 'leftside',
          section: '',
          key: 'gamification'
        },
        {
          path: '/gallery',
          name: LocalStrings.kGallery,
          languageKey: 'kGallery',
          icon: appIcons.galleryIcon,
          // component: Gallery,
          component: LazyGallery,
          display: true,
          position: 'leftside',
          section: '',
          key: 'gallery'
        },
        {
          path: '/survey',
          name: LocalStrings.kSurveyText,
          languageKey: 'kSurveyText',
          icon: appIcons.surveyIcon,
          // component: Survey,
          component: LazySurvey,
          display: true,
          position: 'leftside',
          section: '',
          key: 'survey'
        },
        {
          path: '/agenda',
          name: LocalStrings.kMyAgendaText,
          languageKey: 'kMyAgendaText',
          icon: appIcons.myagendaIcon,
          // component: Agenda,
          component: LazyAgenda,
          display: true,
          position: 'top',
          section: 'menu',
          key: 'agenda'
        },
        {
          path: '/notes',
          name: LocalStrings.kNotesText,
          languageKey: 'kNotesText',
          icon: appIcons.notesIcon,
          // component: Notes,
          component: LazyNotes,
          display: true,
          position: 'top',
          section: 'side',
          key: 'notes'
        },
        {
          path: '/webview',
          name: LocalStrings.webview,
          languageKey: 'webview',
          icon: appIcons.webviewIcon,
          // component: EventWebview,
          component: LazyEventWebview,
          display: true,
          position: 'leftside',
          section: '',
          key: 'webview'
        },
        {
          path: '/maps',
          name: LocalStrings.kMap,
          languageKey: 'kMap',
          icon: appIcons.mapsIcon,
          // component: Maps,
          component: LazyMaps,
          display: true,
          position: 'leftside',
          section: '',
          key: 'maps'
        },
        {
          path: '/mapdetails',
          name: '',
          languageKey: '',
          icon: '',
          // component: MapDetails,
          component: LazyMapDetails,
          display: false,
          section: '',
          position: ''
        },
        {
          path: '/event-guide',
          name: LocalStrings.kEventGuide,
          languageKey: 'kEventGuide',
          icon: appIcons.eventGuideIcon,
          // component: EventGuide,
          component: LazyEventGuide,
          display: true,
          position: 'leftside',
          key: 'about',
          section: 'menu'
        },
        // at bottom as have to keey before logout in dropdown
        {
          path: '/mytickets',
          name: LocalStrings.mytickets,
          languageKey: 'mytickets',
          icon: appIcons.ticketIcon,
          // component: MyTickets,
          component: LazyMyTickets,
          display: true,
          position: 'top',
          section: 'side',
          key: 'tickets'
        },
        {
          path: '/notifications',
          name: '',
          languageKey: '',
          icon: '',
          // component: Notification,
          component: LazyNotifications,
          display: true,
          position: '',
          section: '',
          key: 'notifications'
        },
        {
          path: '/globalsearch',
          name: '',
          languageKey: '',
          icon: '',
          // component: Notification,
          component: LazyGlobalSearch,
          display: true,
          position: '',
          section: '',
          key: 'globalsearch'
        },
        {
          path: '/myyscans',
          name: LocalStrings.kMyScansTitleText,
          languageKey: 'kMyScansTitleText',
          icon: appIcons.qrScanIcon,
          // component: EventGuide,
          component: LazyMyScans,
          display: true,
          position: 'top',
          key: 'myscans',
          section: 'menu'
        }
      ];
export default routes;
